import { PageContext } from './pageContext';

export const isCareersPage = (headers: PageContext) => {
  const { subdomain, path } = headers;

  return subdomain.includes('careers') || path.startsWith('/careers');
};

export const rewriteCareersSlug = (slug: string) => {
  if (!slug) return '';
  return slug.trim().replace(/^careers(?:\/)?/, '');
};
